import React, { useContext, useRef } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import ModalSave from "../../common/ModelSave";
import { CancelButton, SaveButton } from "../../common/Button";
import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import Select from "react-select";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const videoRef = useRef(null);
  const { postData, getData, IMG_URL, getDimension } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const [videoPreview, setVideoPreview] = useState(null);
  const GetEditData = async () => {
    const response = await getData(`/masters/website-type/${id}`);
    reset(response?.data);
    setImagePreview(IMG_URL + response?.data?.video);
    setVideoPreview(IMG_URL + response?.data?.video);
  };
  useEffect(() => {
    GetEditData();
  }, []);
  console.log(videoPreview, "videoPreview");

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    getValues,
    watch,
    setValue,
  } = useForm();

  const videoFile = watch("video");

  const onSubmit = async (data) => {
    try {
      console.log(data);
      const finalData = new FormData();
      finalData.append("type", data?.type?.value);
      finalData.append("name", data?.name);
      finalData.append("sub_name", data?.sub_name);
      finalData.append("video", data.video[0]);
      const response = await postData(`/masters/website-type/${id}`, finalData);
      console.log(response);
      if (response?.success) {
        props.getDataAll();
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("video")) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setVideoPreview(reader.result); // Set video preview
      };
      reader.readAsDataURL(file);
      // setValue('video', file); // Update the form value
    } else {
      // Optionally, handle the case when the selected file is not a video
      alert("Please select a video file.");
    }
  };

  const options = [
    { value: "Image", label: "Image" },
    { value: "Video", label: "Video" },


  ];
  console.log(getValues(), "gggggggggggggggggggggggggggggggggggg");

  const [imagePreview, setImagePreview] = useState(null); // State to store image preview

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result); // Set image preview
      };
      reader.readAsDataURL(file);
    }
  };
  const selectedType = watch("type");
  console.log(selectedType, 'selectedType selectedType');

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Website Type
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row className="justify-content-center">
              <Col md={6}>
                <div className="main-form-section my-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>Name</Form.Label>

                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Name"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "Name Is Required",
                          })}
                        />
                      </InputGroup>
                      {errors.name && (
                        <span className="text-danger">
                          {errors.name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>

                {/*  */}
              </Col>
              <Col lg={6}>
                <div className="main-form-section my-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>Sub Name</Form.Label>

                      <InputGroup>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="Sun Tital"
                          className={classNames("", {
                            "is-invalid": errors?.sub_name,
                          })}
                          {...register("sub_name", {
                            required: "sub name Is Required",
                          })}
                        />
                      </InputGroup>
                      {errors.sub_name && (
                        <span className="text-danger">
                          {errors.sub_name.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section my-3">
                  <Row className="justify-content-center">
                    <Form.Group>
                      <Form.Label>Type</Form.Label>

                      <InputGroup>
                        <Controller
                          name="type" // Field name in form data
                          control={control}
                          rules={{ required: "Type is required" }}
                          defaultValue={null} // Set initial value
                          render={({ field }) => (
                            <Select
                              {...field} // spread the field props
                              options={options}
                              placeholder="type"
                              classNamePrefix="selectHolder"
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption); // Update form state with selected option
                              }}
                            />
                          )}
                        />
                      </InputGroup>
                      {errors.type && (
                        <span className="text-danger">
                          {errors.type.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                </div>

              </Col>
              {selectedType?.value == "Image" && (
                <Col md={6}>
                  <div className="main-form-section mt-3">
                    <Form.Group>
                      <div className="text-center">
                        <Form.Label>Image</Form.Label>
                      </div>
                      <InputGroup>
                        <Form.Control
                          className={classNames("", {
                            "is-invalid": errors?.video,
                          })}
                          type="file"
                          {...register("video", {
                            validate: async (value) => {
                              if (typeof value !== "string") {
                                const fileTypes = ["jpg", "png", "jpeg"];
                                const fileType = value[0].name?.split(".")[1];

                                // if (!fileTypes.includes(fileType)) {
                                //   return `please upload a valid file format. (${fileTypes})`;
                                // }

                                // const sizes = await getDimension(value[0]);
                                // if (sizes.width !== 200 && sizes.height !== 260) {
                                //   return "Image width and height must be 200 px and 260 px";
                                // }

                                // const fileSize = Math.round(
                                //   value[0].size / 1024
                                // );
                                // if (fileSize > 500) {
                                //   return "file size must be lower than 500kb";
                                // }
                              }
                            },
                          })}
                          onChange={handleImageChange}
                          accept=".jpg, .jpeg, .png"
                          multiple={false}
                        />
                      </InputGroup>
                      {errors.video && (
                        <span className="text-danger">
                          {errors.video.message}
                        </span>
                      )}
                    </Form.Group>
                    {imagePreview && (
                      <div className="mt-2">
                        <img
                          src={imagePreview}
                          alt="Category Preview"
                          style={{ maxWidth: "100px" }}
                        />
                      </div>
                    )}
                  </div>
                </Col>
              )}
              {selectedType?.value == "Video" && (

                <>
                  <Col lg={6}>
                    <div className="main-form-section my-3">
                      <Row className="justify-content-center">
                        <Form.Label column sm={3} className="text-center">
                          Video
                        </Form.Label>
                        <Col sm={9}>
                          <Form.Group>
                            <Form.Control
                              className={classNames("", {
                                "is-invalid": errors?.video,
                              })}
                              type="file"
                              {...register("video", {
                                // required: "image1 is required",
                                // validate: async (value) => {
                                //   const fileTypes = ["jpg", "png", "jpeg"];
                                //   const fileType = value[0].name.split(".")[1];
                                //   if (!fileTypes.includes(fileType)) {
                                //     return `please upload a valid file format. (${fileTypes})`;
                                //   }
                                //   const sizes = await getDimension(value[0]);
                                //   if (sizes.width !== 285 && sizes.height !== 298) {
                                //     return "Image width and height must be 285px and 298px";
                                //   }
                                //   const fileSize = Math.round(value[0].size / 1024);
                                //   if (fileSize > 500) {
                                //     return "file size must be lower than 500kb";
                                //   }
                                // },
                              })}
                              accept="video/mp4, video/x-m4v, video/*"
                            />
                          </Form.Group>
                          {errors.video && (
                            <span className="text-danger">
                              {errors.video.message}
                            </span>
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="main-form-section my-3">
                      <Row className="justify-content-center">
                      <Form.Label className="text-center">Video Preview</Form.Label>
                        <Col sm={9}>
                          {typeof getValues("video") == "string" ? (
                            <div className="image-preview-container">
                              <video
                                src={IMG_URL + getValues("video")}
                                alt="Preview"
                                className="image-preview"
                                style={{ width: "150px", height: "130px" }}
                                muted
                                controls
                              />
                            </div>
                          ) : (
                            videoFile &&
                            videoFile?.length > 0 && (
                              <div className="image-preview-container">
                                <video
                                  // src={URL.createObjectURL(getValues("image")[0])}
                                  src={URL?.createObjectURL(videoFile[0])}
                                  alt="Preview"
                                  className="image-preview"
                                  style={{ width: "150px", height: "130px" }}
                                  controls
                                  muted
                                />
                              </div>
                            )
                          )}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </>
              )}

              {/*  */}



              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal >

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditOffCanvance;
